import axios from './http';

export default {
  getAllFaculties: () => axios.get('api/faculties/'),
  getAllDepartments: () => axios.get('api/departments/'),
};
